export default __webpack_public_path__ + "static/media/221091_info.2915eff1.pdf";